"use client";

import { useStorage } from "../useStorage";
import {
    Dialog,
    DialogContent,
    DialogHeader,
    DialogTitle,
} from "@/components/ui/dialog";
import { StorageQueryProvider } from "@/app/[locale]/(platform)/storage/hooks/storageQueryProvider";
import FolderSettingsModal from "@/app/[locale]/(platform)/storage/components/modals/folderSettingsModal";
import DeleteFolderModal from "@/app/[locale]/(platform)/storage/components/modals/deleteFolderModal";
import CreateFolderModal from "@/app/[locale]/(platform)/storage/components/modals/createFolderModal";
import SelectedItemsMenu from "@/app/[locale]/(platform)/storage/components/ui/selectedItemsMenu";
import StorageHeader from "@/app/[locale]/(platform)/storage/components/ui/header/header";
import Storage from "@/app/[locale]/(platform)/storage/components/storage";
import { InformationCircleIcon } from "@heroicons/react/20/solid";
import StoragePadding from "@/app/[locale]/(platform)/storage/components/ui/padding";

export default function StorageExplorerModal() {
    const [open, setOpen, settings] = useStorage((state) => [
        state.explorerOpen,
        state.setExplorerOpen,
        state.explorerSettings,
    ]);

    return (
        <Dialog
            open={open}
            onOpenChange={(open: boolean) => {
                setOpen(open);
            }}
        >
            <DialogContent
                className="
            bg-muted flex flex-col p-0 gap-0 overflow-hidden
            min-h-[400px] min-w-full lg:max-h-[90vh] lg:min-w-[900px] xl:min-w-[1000px]
            "
            >
                <DialogHeader className="text-start bg-accent border-b border-b-primary px-6 py-4">
                    <DialogTitle className="sr-only">
                        Storage Explorer
                    </DialogTitle>
                    <div className="flex gap-3">
                        <InformationCircleIcon className="shrink-0 size-5 text-blue-400" />
                        <p className="text-sm text-blue-700 pe-4">
                            {settings.description}
                        </p>
                    </div>
                </DialogHeader>
                <StorageQueryProvider settings={settings}>
                    <FolderSettingsModal />
                    <DeleteFolderModal />
                    <CreateFolderModal />

                    <SelectedItemsMenu containerId="selected-menu-root" />

                    <main className="px-6 pt-6 flex-1 flex flex-col w-full gap-y-12 overflow-y-auto">
                        <StorageHeader />
                        <Storage />
                        <StoragePadding
                            classNameWhenSelectedItemsMenuIsHidden="pb-1"
                            classNameWhenSelectedItemsMenuIsShown="pb-10"
                        />
                    </main>

                    <div id="selected-menu-root" />
                </StorageQueryProvider>
            </DialogContent>
        </Dialog>
    );
}
